import * as React from "react";

import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { useTranslation } from "react-i18next";


import type { AuthContextType } from "@/context/auth";
import { Logger } from "@/utils/logger";

import type { QueryClient } from "@tanstack/react-query";

function RouteError({ error }: { error: unknown }) {
  const { t } = useTranslation("common");
  Logger.error("Route error", {
    error: String((error as any)?.message ?? error),
  });
  return <div className="p-4">{t("errors.routeError")}</div>;
}

interface MyRouterContext {
  auth: AuthContextType | undefined;
  queryClient: QueryClient;
}
export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: RootComponent,
  errorComponent: RouteError,
});

function RootComponent() {
  return (
    <React.Fragment>
      <Outlet />

      {import.meta.env.DEV ? <TanStackRouterDevtools /> : null}
    </React.Fragment>
  );
}
